import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=57e5a813&scoped=true&"
import script from "./integrations.vue?vue&type=script&lang=js&"
export * from "./integrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e5a813",
  null
  
)

export default component.exports